import { useMutation, useQuery } from "@tanstack/react-query";

import {
  adminGrantCourseAccess,
  getUserCourseAccesses,
  updateUserCourseAccess,
} from "@/api";

export const userCourseAccessQueryKeys = {
  useUserCourseAccess: () => ["userCourseAccess"] as const,
  useUserCourseAccessForUser: (userId: string) =>
    ["userCourseAccess", "forUser", userId] as const,
};

export const useUserCourseAccess = () => {
  const useAdminGrantCourseAccess = () =>
    useMutation({ mutationFn: adminGrantCourseAccess });

  const useUserCourseAccessesForUser = (userId: string) =>
    useQuery({
      queryKey: userCourseAccessQueryKeys.useUserCourseAccessForUser(userId),
      queryFn: () => getUserCourseAccesses(1, userId, 100),
      enabled: !!userId,
    });

  const useUpdateUserCourseAccess = () =>
    useMutation({ mutationFn: updateUserCourseAccess });

  return {
    useAdminGrantCourseAccess,
    useUserCourseAccessesForUser,
    useUpdateUserCourseAccess,
  };
};
